const config = { appName: "kefi-bundles", appHandle: "kefi-bundles-app" };
export const BACKEND_URL = "https://api.keficommerce.com";
// export const BACKEND_URL = "http://localhost:3001";
// export const BACKEND_URL = "https://rightly-massive-sailfish.ngrok-free.app";

// export const BACKEND_URL = "https://aware-daily-sloth.ngrok-free.app";
export const PROD = true;
export const mixpanelKey = PROD ? "bbd77f6552c5857f6bf1ec9d4957ac2b" : "8d1ad9b86245747f7b994112d1d24aec";
export const iComKey = "tlxy4xq3";
export const userDotComKey = "tfy1yd";
export const mantleWidgetId = "a9c50572-a8da-4119-8d77-7e15465b1f2f";
export default config;

export const SentryDSN = import.meta.env.PROD
    ? "https://6ed9bf8226c232ff09405fae742a761a@o1295381.ingest.us.sentry.io/4508998400540672"
    : "";
